/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Extraction_ProtocolInputs */

const en_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Extraction Protocol`)
};

const es_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocolo de extracción IA`)
};

const fr_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocole d'extraction IA`)
};

const de_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Extraktionsprotokoll`)
};

const ja_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI抽出プロトコル`)
};

const zh_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 提取协议`)
};

const ar_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بروتوكول الاستخراج بالذكاء الاصطناعي`)
};

const id_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol Ekstraksi AI`)
};

const it_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocollo di Estrazione IA`)
};

const ru_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Протокол извлечения ИИ`)
};

const pt_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocolo de Extração IA`)
};

const ko_ai_extraction_protocol = /** @type {(inputs: Ai_Extraction_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 추출 프로토콜`)
};

/**
* | output |
* | --- |
* | "AI Extraction Protocol" |
*
* @param {Ai_Extraction_ProtocolInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_extraction_protocol = /** @type {((inputs?: Ai_Extraction_ProtocolInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Extraction_ProtocolInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_extraction_protocol(inputs)
	if (locale === "es") return es_ai_extraction_protocol(inputs)
	if (locale === "fr") return fr_ai_extraction_protocol(inputs)
	if (locale === "de") return de_ai_extraction_protocol(inputs)
	if (locale === "ja") return ja_ai_extraction_protocol(inputs)
	if (locale === "zh") return zh_ai_extraction_protocol(inputs)
	if (locale === "ar") return ar_ai_extraction_protocol(inputs)
	if (locale === "id") return id_ai_extraction_protocol(inputs)
	if (locale === "it") return it_ai_extraction_protocol(inputs)
	if (locale === "ru") return ru_ai_extraction_protocol(inputs)
	if (locale === "pt") return pt_ai_extraction_protocol(inputs)
	return ko_ai_extraction_protocol(inputs)
});